<template>
  <div id="user-manage">
    <!--搜索-->
    <div class="top">
      <el-col :span="12">
        <el-input
          placeholder="请输入用户昵称、关联代理商"
          v-model="input"
          class="input-with-select"
          clearable
          style="width: 100%"
        >
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
    </div>
    <!--表格-->
    <div class="user-table">
      <el-table border :data="tableData">
        <el-table-column 
          label="序号" 
          align="center" 
          width="50">
          <template slot-scope="scope">
            {{ (scope.$index+1)+pageSize*(currentPage-1)}}
          </template>
        </el-table-column>
        <el-table-column
          label="用户名"
          align="center"
          width="120"
          show-overflow-tooltip
          prop="nickName"
        ></el-table-column>
        <!-- <el-table-column label="性别" align="center" width="60" prop="gender"></el-table-column> -->
        <el-table-column label="OpenId" align="center" show-overflow-tooltip prop="openId"></el-table-column>
        <el-table-column label="所属代理" align="center" width="100" show-overflow-tooltip prop="seller"></el-table-column>
        <el-table-column label="最近登录" align="center" width="200" prop="lastLogin"></el-table-column>
        <el-table-column label="是否禁用" align="center" width="100" prop="isBanned" :formatter="formatBoolean"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getCurrentPageBUser,
  updateUserInfo
} from "../../../api/index";
import { MessageBox, Message } from "element-ui";
import {banUserById} from "../../../api/index";
export default {
  name: "UserManage",
  data() {
    let checkName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("用户名不能为空！"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else {
        if (/^1[3|4|5|6|7|8][0-9]{9}$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确格式的手机号码"));
        }
      }
    };
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      //服务器地址
      server: "http://localhost:8080",
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 15,
      userInfo: {},
      dialogFormVisible: false,
      dialogTitle: "",
      labelPosition: "right",
      input: "",
      searchInput: "",
      rules: {
        user_name: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      pickerBirthday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created() {
    this.loadCurrentPageUser(this.currentPage, this.pageSize, "");
  },
  methods: {
    async loadCurrentPageUser(currentPage, pageSize, input) {
      const sellerId = this.$cookies.get("sellerId");
      let json = await getCurrentPageBUser(currentPage, pageSize, input, sellerId);
      if (json.state === 200) {
        this.tableData = json.data.beanList;
        this.total = json.data.tr;
      }
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.loadCurrentPageUser(this.currentPage, this.pageSize, this.searchInput);
    },
    formatBoolean: function (row, column, cellValue) {
      var ret = ''  //你想在页面展示的值
      if (cellValue) {
        ret = "是"  //根据自己的需求设定
      } else {
        ret = "否"
      }
      return ret;
    },
    cancel() {
      this.loadCurrentPageUser(this.currentPage, this.pageSize, this.searchInput);
      this.dialogFormVisible = false;
    },
    //搜索用户
    search() {
      this.searchInput = this.input;
      this.loadCurrentPageUser(1, this.pageSize, this.searchInput);
    },
  }
};
</script>

<style scoped>
.user-table {
  width: 95%;
  min-width: 900px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 30px 0; */
  margin-bottom: 30px;
}
.block {
  text-align: center;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body .el-form-item {
  padding-left: 20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/children/UserManage.vue